var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import platform from "platform";
var SubstitutionsManager = /** @class */ (function () {
    function SubstitutionsManager() {
        this.substitutions = {
            RCODE: this.getRcode(),
            BROWSER: this.getBrowser(),
            LANG: this.getLanguage(),
            MACHINE: this.getMachineModel(),
            OS: this.getOs(),
        };
        this.env = process.env.REACT_APP_ENV || "";
    }
    SubstitutionsManager.prototype.getRcode = function () {
        return process.env.REACT_APP_RCODE || "";
    };
    SubstitutionsManager.prototype.getOs = function () {
        return "" + platform.os;
    };
    SubstitutionsManager.prototype.getBrowser = function () {
        return platform.layout + " - " + platform.description;
    };
    SubstitutionsManager.prototype.getMachineModel = function () {
        return platform.manufacturer + " " + platform.product;
    };
    SubstitutionsManager.prototype.getLanguage = function () {
        if (window.navigator && window.navigator.language) {
            var language = window.navigator.language;
            // return everything before first `-` "en-GB" returns "en"
            return language.replace(/-.+/g, "");
        }
        return this.getDefaultLanguage();
    };
    SubstitutionsManager.prototype.getAppId = function () {
        return process.env.REACT_APP_APP_ID || "";
    };
    SubstitutionsManager.prototype.getAppPlatform = function () {
        return process.env.REACT_APP_PLATFORM || "";
    };
    SubstitutionsManager.prototype.getAppVersion = function () {
        return process.env.REACT_APP_VERSION || "";
    };
    SubstitutionsManager.prototype.getAppBuild = function () {
        return process.env.REACT_APP_BUILD || "0";
    };
    SubstitutionsManager.prototype.setEnvironment = function (env) {
        this.env = env;
    };
    SubstitutionsManager.prototype.getEnvironment = function (canSwitchEnvironments) {
        if (canSwitchEnvironments === void 0) { canSwitchEnvironments = false; }
        if (canSwitchEnvironments) {
            return localStorage.getItem(this.getAppId() + "-env") || this.env;
        }
        return this.env;
    };
    SubstitutionsManager.prototype.getDefaultLanguage = function () {
        return process.env.REACT_APP_DEFAULT_LANG || "";
    };
    SubstitutionsManager.prototype.applySubsitutions = function (value, extraSubs) {
        var _this = this;
        if (extraSubs === void 0) { extraSubs = {}; }
        var subs = __assign(__assign({}, this.substitutions), extraSubs);
        Object.keys(subs).forEach(function (subKey) {
            var sub = subs[subKey];
            if (sub !== undefined) {
                value = _this.substitute(value, subKey, sub);
            }
        });
        return value;
    };
    SubstitutionsManager.prototype.substitute = function (subString, key, value) {
        var reg = new RegExp("{" + key + "}", "g");
        return subString.replace(reg, value);
    };
    return SubstitutionsManager;
}());
export default SubstitutionsManager;
